<template>
  <div class="row">
    <div class="offset-lg-3 style-paper col-lg-6 text-center">
      <h1>{{ title }}</h1>
      <div id="content">
        <slot/>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }    
}
</script>

<style scoped>
  .max-height {
    height: 80vh;
  }
  .style-paper {
    -moz-transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
    -ms-transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
    -o-transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
    -webkit-transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
    background-color: #fff;
    border: 0;
    border-radius: 3px;
    box-shadow: 0 6px 10px -4px rgba(0,0,0,.15);
    color: #252422;
    margin-bottom: 20px;
    position: relative;
    transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
    padding: 50px;
  }
  .offset-lg-3 {
    margin-left: 25% !important;
  }
  #content {
    font-size: 18px;
  }
</style>
